"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFormatValue = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable react/forbid-prop-types */

var CustomFormatValue = exports.CustomFormatValue = function CustomFormatValue(_ref) {
  var parentField = _ref.parentField,
    productDefinition = _ref.productDefinition,
    valueMap = _ref.valueMap,
    _ref$formatters = _ref.formatters,
    formatters = _ref$formatters === void 0 ? {
      label: function label() {},
      value: function value() {},
      displayValue: null
    } : _ref$formatters;
  var value;
  if (parentField) {
    var totalValue = 0;
    var numberOfValues = 0;
    if (Array.isArray(productDefinition[parentField])) {
      productDefinition[parentField].forEach(function (valueItem) {
        totalValue += valueItem[valueMap.value];
        numberOfValues += 1;
      });
    }
    value = totalValue > 0 && numberOfValues > 0 ? totalValue / numberOfValues : 0;
  } else if (valueMap && valueMap.value) {
    value = productDefinition[valueMap.value];
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelValue"
  }, formatters && formatters.displayValue ? formatters.displayValue(value) : value);
};
CustomFormatValue.propTypes = {
  parentField: _propTypes["default"].string,
  productDefinition: _propTypes["default"].any,
  valueMap: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  formatters: _propTypes["default"].shape({
    label: _propTypes["default"].func,
    value: _propTypes["default"].func,
    displayValue: _propTypes["default"].func
  })
};